import { defineStore } from 'pinia'
import axios from 'axios'
import { useUserStore } from './userStore'
import { useDialogAlertStore } from './dialogAlertStore'
import { useBalanceStore } from './balanceStore'


export const usePriceGiftAdenaStore = defineStore({
  id: 'available_codes',
  state: () => ({
    price_data: null,
    user_variant_dialog:false


  }),

  actions: {
    async get_available_codes(server_id) {
          try {
            const user = useUserStore()
            if (user.user.access_token == null) {
                var uri = '/api/varianty_adeny_za_kod/' + server_id
                }
            else {
                    axios.defaults.headers.common['Authorization'] = "Bearer " + user.user.access_token
                    var uri = '/api/auth_varianty_adeny_za_kod/' + server_id  
                }
            const response = await axios.get(uri)  
            this.price_data = response.data //.sort((a,b) => a.price - b.price) 
            if (this.price_data.svoy_variant_kods) {
              this.price_data.svoy_variant_kods.forEach(element => {
                this.price_data.kods.push(element)
              });
              delete this.price_data['svoy_variant_kods'];     
            } 
                
            useBalanceStore().get_balance(this.price_data)
            return this.price_data
          } catch (e) {
            console.log(e)
          }
      },

      

    async show_code(data) {
 
      try {
        const user = useUserStore()
        let code = data.code
        if (user.user.access_token == null) return false           
        axios.defaults.headers.common['Authorization'] = "Bearer " + user.user.access_token
        code.wallet_id = data.wallet.id
        const response = await axios.post('/api/show_code/', code)
        if (response.data.success) {
          useBalanceStore().minus_balance(response.data.summa)
          let i = this.price_data.kods.findIndex(a => a.id === code.id)
          console.log(i);         
          Object.assign(this.price_data.kods[i], { sert:response.data.sert, status: response.data.status})
          
        }
        if (response.data.errors && response.data.errors.status) {
          let i = this.price_data.kods.findIndex(a => a.id === code.id)
          this.price_data.kods[i].status = response.data.errors.status
        }
        return response
      } catch (e) {
        console.log(e)
      }
  },
  async activation_code(code) {
 
    try {
      const user = useUserStore()
      if (user.user.access_token == null) return false           
      axios.defaults.headers.common['Authorization'] = "Bearer " + user.user.access_token
      const response = await axios.post('/api/activation_code/', code)
      if (response.data.success && this.price_data.user_code) this.price_data.user_code.status = response.data.success
      if (response.data.errors) {
      const dialog = useDialogAlertStore()
      dialog.dialog_alert_open({text: response.data.errors, status: true, timeout: 1000})
      }
      return response
    } catch (e) {
      console.log(e)
    }
},
  async save_nick(nick) {
 
    try {
      const user = useUserStore()
      if (user.user.access_token == null) return false           
      axios.defaults.headers.common['Authorization'] = "Bearer " + user.user.access_token
      const response = await axios.post('/api/save_nick/', nick)
      if (response.data.success) this.price_data.save_nick = response.data.success
      return response
    } catch (e) {
      console.log(e)
    }
},

async delete_user_variant(id) {
  let i = this.price_data.pricekods.findIndex(a => a.id === id)
  this.price_data.pricekods.splice(i, 1)
},

async edit_user_variant(data) {
  let i = this.price_data.pricekods.findIndex(a => a.id === data.id)
  Object.assign(this.price_data.pricekods[i], data)
 
},

async add_user_variant(data) {
  this.price_data.pricekods.push(data)
},
async add_limit_otvetka(data) {

  try {
    const user = useUserStore()
    if (user.user.access_token == null) return false           
    axios.defaults.headers.common['Authorization'] = "Bearer " + user.user.access_token
    const response = await axios.post('/api/add_limit_otvetka/', data)
    if (response.data.success) this.price_data.telegram_price =  response.data.success

    return response
  } catch (e) {
    console.log(e)
  }
}, 
async del_limit_otvetka(data) {

  try {
    const user = useUserStore()
    if (user.user.access_token == null) return false           
    axios.defaults.headers.common['Authorization'] = "Bearer " + user.user.access_token
    const response = await axios.post('/api/del_limit_otvetka/', data)
    if (response.data.success) this.price_data.telegram_price = null
    return response
  } catch (e) {
    console.log(e)
  }
},  

change_code_status(data) {
  if (this.price_data?.user_kod) {
    this.price_data.user_kod.status = data.code_status
  }   
  if (this.price_data?.kods) {
    let i = this.price_data.kods.findIndex(a => a.id === data.code_id)
    if (i > -1) Object.assign(this.price_data.kods[i], { status: data.code_status})   
    
  }
  if (data.sert) {
      if(this.price_data?.id == data.gamesserver_id) { 
        let new_code = { id: data.code_id, nominal: data.nominal, status:data.code_status, gamesserver_id: data.gamesserver_id}
        this.price_data.kods.push(new_code)
        //console.log(this.price_data.kods)
      }
  }
  if (data.del_sert) {
    if(this.price_data?.id == data.gamesserver_id) { 
      let i = this.price_data.kods.findIndex(a => a.id === data.code_id)
      if (i > -1) this.price_data.kods.splice(i, 1)  
     
    }
}
  }
 

  }
})
